import Button, { ButtonProps } from './button'
import { Icon } from 'components/common'

export interface ArrowButtonProps
  extends Omit<ButtonProps, 'icon' | 'children'> {
  direction: 'left' | 'right'
}

export const ArrowButton = ({
  direction = 'left',
  ...rest
}: ArrowButtonProps): JSX.Element => (
  <>
    <Button
      icon={
        direction === 'left' ? <Icon.LeftOutlined /> : <Icon.RightOutlined />
      }
      {...rest}
    />
  </>
)
